import {svgIconWrapper} from '../svg-icon-wrapper';

import QuickbooksRegular from './quickbooks-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <QuickbooksRegular {...props} />;
}

SvgComponent.iconName = 'quickbooksRegular';

export const QuickbooksRegularIcon = svgIconWrapper(SvgComponent);
